import {
  initialState,
  Actions,
  State,
  GET_SUBSCRIBER_TELEGRAM_GROUP,
  GET_SUBSCRIBER_TELEGRAM_GROUP_SUCCESS,
  GET_SUBSCRIBER_TELEGRAM_GROUP_ERROR,
} from "../../types/group/get-subscriber-telegram-group";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_SUBSCRIBER_TELEGRAM_GROUP:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_SUBSCRIBER_TELEGRAM_GROUP_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_SUBSCRIBER_TELEGRAM_GROUP_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
